import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {AvailableDatesService} from "../actions";
import {addToSessionObject} from "../utils";
import moment from "moment";

export const fetchAvailableDepartureDates = (body: any) => async (dispatch: Dispatch) => {
    const response = await AvailableDatesService.getDates(body);
    dispatch(setAvailableDepartureDates(response.availableDates));
}

export const fetchAvailableReturnDates = (body: any) => async (dispatch: Dispatch, getState: () => any) => {
    const response = await AvailableDatesService.getDates(body);
    const avail = response.availableDates ?? [];
    dispatch(setAvailableReturnDates(avail));

    const home = getState().home;
    if (!home.oneWay && home.dates?.[1] != null && avail.length === 0) {
        dispatch(dates([home.dates[0] ?? null, null]));
    }
}

export const clearAvailableDates = () => async (dispatch: Dispatch) => {
    dispatch(clearDates());
}

export const setFromAirport = (body: any) => async (dispatch: Dispatch) => {
    dispatch(fromAirport(body));
}
export const setToAirport = (body: any) => async (dispatch: Dispatch) => {
    dispatch(toAirport(body));
}
export const setDates = (body: any) => async (dispatch: Dispatch) => {
    dispatch(dates(body));
}
export const setAdults = (body: any) => async (dispatch: Dispatch) => {
    dispatch(adults(body));
}
export const setChildren = (body: any) => async (dispatch: Dispatch) => {
    dispatch(children(body));
}
export const setInfants = (body: any) => async (dispatch: Dispatch) => {
    dispatch(infants(body));
}
export const setOneWay = (body: any) => async (dispatch: Dispatch) => {
    dispatch(oneWay(body));
}

export const resetHomeForm = () => (dispatch: Dispatch) => {
    dispatch(fromAirport(""));
    dispatch(toAirport(""));
    dispatch(dates([]));
    dispatch(clearDates());
    dispatch(adults(1));
    dispatch(children(0));
    dispatch(infants(0));
    dispatch(oneWay(false));
}

interface SelectedFlightSlice {
    fromAirport: string;
    toAirport: string;
    dates: Array<any>;
    adults: number;
    children: number;
    infants: number;
    availableDepartureDates: Array<any>;
    availableReturnDates: Array<any>;
    oneWay: boolean;
}

const HOME_SESSION_KEY = "pr_jet_home_data";

const initialState = (): SelectedFlightSlice => {
    let sessionData: Record<string, any> | null = null;

    try {
        const raw = (window as any).sessionStorage?.getItem(HOME_SESSION_KEY);
        if (raw) {
            sessionData = JSON.parse(raw);
            if (sessionData?.dates?.length) {
                if (sessionData.dates[0]) sessionData.dates[0] = moment(sessionData.dates[0]);
                if (sessionData.dates[1]) sessionData.dates[1] = moment(sessionData.dates[1]);
            }
        }
    } catch (error) {
        sessionData = null;
        console.warn("pr_jet_home_data session read failed", error);
    }

    return {
        fromAirport: "",
        toAirport: "",
        dates: [],
        adults: 1,
        children: 0,
        infants: 0,
        availableDepartureDates: [],
        availableReturnDates: [],
        oneWay: false,
        ...sessionData
    };
}

const stateSlice = createSlice({
    name: 'home',
    initialState: initialState(),
    reducers: {
        fromAirport: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "fromAirport", action.payload);
            state.fromAirport = action.payload
        },
        toAirport: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "toAirport", action.payload);
            state.toAirport = action.payload
        },
        dates: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "dates", action.payload);
            state.dates = action.payload
        },
        adults: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "adults", action.payload);
            state.adults = action.payload
        },
        children: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "children", action.payload);
            state.children = action.payload
        },
        infants: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "infants", action.payload);
            state.infants = action.payload
        },
        setAvailableDepartureDates: (state: any, action) => {
            state.availableDepartureDates = action.payload
        },
        setAvailableReturnDates: (state: any, action) => {
            state.availableReturnDates = action.payload
        },
        oneWay: (state: any, action) => {
            addToSessionObject(HOME_SESSION_KEY, "oneWay", action.payload);
            state.oneWay = action.payload
        },
        clearDates: (state: any) => {
            state.availableDepartureDates = []
            state.availableReturnDates = []
        },
    }
});

export const {fromAirport, toAirport, dates, adults, children, infants, setAvailableDepartureDates, setAvailableReturnDates, clearDates, oneWay} = stateSlice.actions;

export default stateSlice.reducer;
